export default "__VITE_ASSET__0Fj4$4wA__"